
import { Component, Vue } from "vue-property-decorator";
import { Form, Message, Upload } from "element-ui";
import { cloneDeep } from "lodash";
import { IHqPackingListModel, IUserModel } from "@/api/types";
import {
  addRemark,
  batchDeleteHqPackingList,
  confirmWarehousing,
  createDeliveryTime,
  createEmptyHqPackingList,
  deleteInventoryList,
  doMatch,
  downloadHqPackingList,
  downloadInventoryListExcel,
  downloadMatchResult,
  fetchDetailsOfOssUrls,
  getHqPackingListStates,
  getInventoryList,
  getPackingLists,
  getProblemPackingInfo,
  reUploadPackingList,
  updatePackingListFile,
  updateDeliveryTime,
  updateInventoryList,
  uploadPackingList,
  getCustomsPackingInfoWithCombiningDifferentPackingList,
  updateAccountPeriodStartTime,
  getProductsBatch,
  putProductsBatch,
  markErrorStatus, leaveToPurchasing,
} from "@/api/hq-packing-list";
import { defaultDeliveryNoteData, getDeliveryNote } from "@/api/delivery-note";
import Pagination from "@/components/Pagination/index.vue";
import { HqPackingListType } from "@/commons/HqPackingListType";
import { HqPackingListParentInfo } from "@/model/HqPackingListParentInfo";
import { getFactoryLoadingPlan } from "@/api/factory-loading-plans";
import {
  deleteProblemCustomsPacking,
  getAllCustomsPackingProblemTypes,
  updateProblemCustomsPackingState,
} from "@/api/customs-packing";
import {
  createWarehouseReceipt,
  updateWarehouseReceipt,
  getWarehouseReceipt,
  getWarehouseReceiptOriginalInfo,
  getWarehouseReceipts,
} from "@/api/warehouse-receipt";
import { getUsersByJobPositions } from "@/api/users";
import {
  createFactoryDeliveryNote,
  getFactoryDeliveryNote,
  getFactoryDeliveryNoteOriginalInfo,
  getFactoryDeliveryNoteDetail,
  downFactoryDeliveryNote,
} from "@/api/factory-delivery-note";
import HqPackingListProductList from "@/views/components/HqPackingListProductList.vue";
import CustomsPackingStatistics from "@/views/components/CustomsPackingStatistics.vue";
import HistoryProblem from "@/views/warehouse-management/components/HistoryProblem.vue";

import { getReceiveList } from "@/api/receive-list";
import {
  HqPackingListAggregateInfo,
  HqPackingListDetail,
  InventoryList,
  TableRowData,
} from "@/model/HqPackingListModels";
import { downloadFiles } from "@/utils/oss-download";
import { ElUpload, ElUploadInternalFileDetail } from "element-ui/types/upload";
import Template from "@/views/system-management/template/index.vue";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
import Docxtemplater from "docxtemplater";
import { findByCode } from "@/api/supplier";
import user from "@/views/system-management/configuration/user/index.vue";
import { UserModule } from "@/store/modules/user";
import { userInfo } from "os";
import { deepClone } from "@/utils/deepClone";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { HqPackingList } from "@/model/inventory-plan";
import { PACKING_LIST_PARENT } from "@/constant/index";
import { createLoadingPlanList } from "@/api/booking-order";
import { getCanReUpload } from "@/api/hq-packing-list";
import ReceiptNotePreview from "@/views/inbound-management/ReceiptNotePreview.vue";
import FactoryDeliveryNotePreview from "@/views/inbound-management/FactoryDeliveryNotePreview.vue";

@Component({
  name: "HqPackingListManagement",
  components: {
    FactoryDeliveryNotePreview,
    ReceiptNotePreview,
    Template,
    CustomsPackingStatistics,
    HqPackingListProductList,
    Pagination,
    HistoryProblem,
  },
})
export default class extends Vue {
  private factoryDeliveryNoteDialogVisible = false;
  private activeName = "factoryDeliveryNote";

  private tableKey = 0;
  private showBatch = false;
  private hqPackingListParentInfo: HqPackingListParentInfo =
    new HqPackingListParentInfo();
  private type = "";
  private hqPackingLists:any = [];
  private total = 0;
  private listLoading = true;
  private showFileList = true;
  private isShow = false;
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    hqPackingListCode: null,
    states: null,
    factoryName: null,
    stayDays: null,
    parentId: null,
    type: null,
  };
  private files: any[] = [];
  private dialogFormVisible = false;
  private invoiceDialogVisible = false;
  private receiveListDialogVisible = false;
  private dialogStatus = "";
  private invoiceDialogStatus = "";
  private factoryDeliveryNoteDialogStatus = "";
  private batchUploadDialogVisible = false;
  private carriageVehicleTypes: carriageVehicleType[];
  private buttonLoading = false;
  private printInvoiceVisible = false;
  private printObj = { id: "printArea", popTitle: "单据" };
  private createInvoiceLoading = false;
  private showUpdateBatch = false;
  hqPackingListStates: [{name: string; desc: string}] = [
    {name: null, desc: null},
  ];
  JOB_POSITION_NAMES: string[] = [
    "TALLY_MAN",
    "FORKLIFT_OPERATOR",
    "DOCUMENT_MANAGER",
    "PRINTER",
    "AUDITOR",
    "TOLL_COLLECTOR",
    "CONSIGNEE",
    "PURCHASER",
  ];
  INVOICE_DIALOG_TITLE_MAP = { create: "开具单据", check: "查看单据" };
  FACTORY_DELIVERY_NOTE_DIALOG_TITLE_MAP = {
    create: "生成子进仓单",
    check: "查看子进仓单",
  };

  EDIT_HQ_PACKING_LIST_DIALOG_TITLE_MAP = {
    createDeliveryTime: "创建进仓时间",
    updateDeliveryTime: "修改进仓时间",
    addRemark: "添加备注",
  };

  private rules = {
    companyCode: [{ required: true, message: "请选择公司", trigger: "blur" }],
    customerCode: [
      { required: true, message: "请输入客户编码", trigger: "blur" },
    ],
    customerName: [
      { required: true, message: "请输入客户简称", trigger: "blur" },
    ],
    factoryCode: [
      { required: true, message: "请输入工厂编号", trigger: "blur" },
    ],
    factoryName: [
      { required: true, message: "请输入工厂名称", trigger: "blur" },
    ],
    purchaser: [{ required: true, message: "请选择采购员", trigger: "blur" }],
    estimatedVolume: [
      { required: true, message: "请输入预计体积", trigger: "blur" },
    ],
    deliveryNoteCode: [
      { required: true, message: "请输入进仓单编号", trigger: "blur" },
    ],
  };

  private jobPositionAndUsersMap = {};
  private problemTypes: ProblemType[] = [];
  private downloadLoading = false;
  private tempData = defaultDeliveryNoteData;
  private allSelectedRows: IHqPackingListModel[] = [];
  private warehouseReceipt: WarehouseReceiptModel = new WarehouseReceiptModel();
  private warehouseReceipts: WarehouseReceiptModel[] = [];
  private factoryDeliveryNote: FactoryDeliveryNoteModel =
    new FactoryDeliveryNoteModel();
  private payload = new WriteHqPackingListInput();
  private createWarehouseReceiptRequest: CreateWarehouseReceiptRequest =
    new CreateWarehouseReceiptRequest();
  private createFactoryDeliveryNoteRequest: CreateFactoryDeliveryNoteRequest =
    new CreateFactoryDeliveryNoteRequest();
  private receiveList: HqPackingListAggregateInfo =
    new HqPackingListAggregateInfo();
  private currentRow: IHqPackingListModel = null;
  private timeHqPackingListIds = [];
  private purchaserList: IUserModel[] = [];
  private originalInfos: OriginalPackingInfo[] = [];
  private combiningCustomsPackingInfoVisible = false;
  private combiningCustomsPackingInfoVisibleGO = false;
  private problemsWithInvoice: Problem[] = [];
  private count = 1;

  // key 是装箱单id
  private ossFileMap: Map<String, OssFile[]> = new Map();
  private showOssFile: OssFile[] = [];
  private showOssFileLoading = false;

  // 报关计划的状态
  private factoryLoadingPlanState: String = undefined;
  private popoverVisible = false;

  private batchCol = [
    {
      label: "采购订单号",
      prop: "purchaseOrder",
      key: "purchaseOrder",
      show: true,
      disabled: false,
    },
    {
      label: "已有批次",
      prop: "batchListChai",
      key: "batchListChai",
      show: true,
      disabled: false,
    },
    {
      label: "本次发货批次",
      prop: "batch",
      key: "batch",
      type: "input",
      show: true,
      disabled: false,
    },
  ] as any;
  private batchList = [] as any;
  private batch_fa_id = "" as any;

  created() {
    this.type = this.$route.params.type;
    this.hqPackingListParentInfo.id = this.$route.params.parentId;
    this.hqPackingListParentInfo.canUpload = this.$route.params.canUpload !== "false";
    this.getHqPackingListInfo();
    this.initHqPackingListStates();
    this.getList();
    this.initJobPositionUsers();
    this.carriageVehicleTypes = [
      { name: "VAN", desc: "厢式车" },
      { name: "FLATBED", desc: "平板车" },
      {
        name: "HIGH_BAR_TRUCK",
        desc: "高栏车",
      },
      { name: "EXPRESS_UNIT_PRICE", desc: "快递费" },
    ];
  }

  private async initHqPackingListStates() {
    const data: any = await getHqPackingListStates();
    this.hqPackingListStates = data;
  }

  private async reUploadToPages(row) {
    await getCanReUpload(row.id).then((res) => {
      console.log("交货校验重新跳转row", row);
      console.log(
        "交货校验重新跳转hqPackingListParentInfo",
        this.hqPackingListParentInfo
      );
      this.$router.push({
        name: "UploadFactoryPackingList",
        query: {
          code: row.code,
          id: row.id,
          parentCode: this.hqPackingListParentInfo.code,
        },
      });
    });
  }

  private async getHqPackingListInfo() {
    let data;
    if (this.type === "delivery-note") {
      data = await getDeliveryNote(this.hqPackingListParentInfo.id);
    } else {
      data = await getFactoryLoadingPlan(this.hqPackingListParentInfo.id);
      data = { ...data, code: data.code };
    }
    this.hqPackingListParentInfo = data;
  }

  private async getList() {
    this.listLoading = true;
    if (this.type === "delivery-note") {
      await this.getPackingListWithDeliveryNote();
    } else {
      await this.getPackingListsWithFactoryLoadingPlan();
    }
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  public handleCommand(command,row) {
    if(command === 'showCombiningCustomsPackingDialogCOME') {
      this.showCombiningCustomsPackingDialog(row.id,true)
    } else {
      this.showCombiningCustomsPackingDialog(row.id,false)
    }
  }

  private async getPackingListWithDeliveryNote() {
    this.listQuery.parentId = this.hqPackingListParentInfo.id;
    this.listQuery.type = HqPackingListType.DELIVERY_NOTE.toUpperCase();
    const { total, content }: any = await getPackingLists(
      this.hqPackingListParentInfo.id,
      this.listQuery
    );
    this.total = total;
    this.hqPackingLists = content;
    this.hqPackingLists.forEach((item,index) => {item.sn = index + 1;})
  }

  private async getPackingListsWithFactoryLoadingPlan() {
    this.listQuery.parentId = this.hqPackingListParentInfo.id;
    this.listQuery.type = HqPackingListType.FACTORY_LOADING_PLAN.toUpperCase();
    const { total, content }: any = await getPackingLists(
      this.hqPackingListParentInfo.id,
      this.listQuery
    );
    this.total = total;
    this.hqPackingLists = content;
    this.hqPackingLists.forEach((item,index) => {item.sn = index + 1;})
  }

  private handleFilter() {
    this.listQuery.pageNumber = 1;
    this.getList();
  }

  private async fetchDetailsOfOssFile(pl: IHqPackingListModel) {
    this.showOssFileLoading = true;
    const response: any = await fetchDetailsOfOssUrls({
      ossIds: pl.ossUrlIds,
    }).finally(() => {
      this.showOssFileLoading = false;
    });
    this.showOssFile = response
        .map((item: any) => OssFile.fromAPIData(item))
        .sort((a: OssFile, b: OssFile) => {
      return a.createdAt.getTime() - b.createdAt.getTime();
    });
  }

  // 如果是报关计划的装箱单，以报关计划的状态为判断依据
  // 如果是出库计划的装箱单，以装箱单的状态为判断依据
  isShowReuploadButton(row) {
    if (this.type === PACKING_LIST_PARENT.factory_loading_plan) {
      return !(
        this.hqPackingListParentInfo.state &&
        this.hqPackingListParentInfo.state.name ===
          "CONTAINER_CONFIGURATION_ALL"
      );
    } else {
      return row.state.canReUploadHqPackingList;
    }
  }

  // 如果是报关计划的装箱单，以报关计划的状态为判断依据
  // 如果是出库计划的装箱单，以装箱单的状态为判断依据
  isShowUpdateFileButton(row) {
    return !this.isShowReuploadButton(row);
  }

  private resetTempData() {
    this.tempData = cloneDeep(defaultDeliveryNoteData);
  }

  private gotoPackingListDetailPage(id: string) {
    this.$router.push({
      name: "HqPackingListDetail",
      params: { hqPackingListId: id, type: this.type },
    });
  }

  private gotoPackageManagementPage(id: string) {
    this.$router.push({
      name: "HqPackingListPackageManagement",
      params: { hqPackingListId: id },
    });
  }

  private gotoImageManagementPage(id: string) {
    this.$router.push({
      name: "ImageManagement",
      params: { bizType: "hq-packing-list", objectId: id },
    });
  }

  private gotoEditPage(id: string) {
    this.$router.push({
      name: "DeliveryHqPackingListDetailForEdit",
      params: { hqPackingListId: id },
    });
  }

  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "HQ_PACKING_LIST", documentId: data.id },
    });
  }

  private onDialogConfirmed() {
    if (
      this.dialogStatus === "createDeliveryTime" ||
      this.dialogStatus === "updateDeliveryTime"
    ) {
      this.doCreateOrUpdateDeliveryTime(this.timeHqPackingListIds);
      this.payload.deliveryStartTime = null;
      this.payload.deliveryEndTime = null;
    } else if (this.dialogStatus === "addRemark") {
      this.doAddRemark();
    }
  }

  private async doAddRemark() {
    await addRemark(this.payload.id, { remark: this.payload.remark });
    this.dialogFormVisible = false;
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private async doCreateOrUpdateDeliveryTime(hqPackingListIds: string[]) {
    const data: any = {
      ids: hqPackingListIds,
      deliveryStartTime: this.payload.deliveryStartTime,
      deliveryEndTime: this.payload.deliveryEndTime,
    };
    if (this.dialogStatus === "createDeliveryTime") {
      await createDeliveryTime(data);
    } else if (this.dialogStatus === "updateDeliveryTime") {
      await updateDeliveryTime(data);
    }
    this.dialogFormVisible = false;
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private showDialog(actionName: string, row: IHqPackingListModel) {
    this.currentRow = row;
    this.payload = cloneDeep(row);
    this.timeHqPackingListIds = [];
    this.timeHqPackingListIds.push(this.payload.id);
    this.dialogStatus = actionName;
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private async showFactoryDeliveryNoteDialog(row: IHqPackingListModel) {
    this.buttonLoading = true;
    this.currentRow = row;
    this.factoryDeliveryNoteDialogStatus = row.factoryDeliveryNoteId
      ? "check"
      : "create";
    if (this.factoryDeliveryNoteDialogStatus === "check") {
      const data: any = await getFactoryDeliveryNote(row.id).catch(() => {
        this.buttonLoading = false;
      });
      this.factoryDeliveryNote = data;
      if (!this.factoryDeliveryNote.factoryDeliveryNote.remark) {
        this.factoryDeliveryNote.factoryDeliveryNote.remark = "";
      }
      this.buttonLoading = false;
      this.factoryDeliveryNoteDialogVisible = true;
    } else {
      await createFactoryDeliveryNote(row.id);
      this.buttonLoading = false;
      await this.getList();
    }
  }

  private showCheckReceiveListDialog(row: IHqPackingListModel) {
    this.currentRow = row;
    this.receiveListDialogVisible = true;
    this.getReceiveListData(row.id);
  }

  private async getReceiveListData(hqPackingListId: string) {
    const data: any = await getReceiveList(hqPackingListId);
    this.receiveList = data;
  }

  private handleCreate() {
    this.resetTempData();
    this.dialogStatus = "create";
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private async putBatch(row) {
    console.log('修改批次',row)
    this.batch_fa_id = row.id
    this.showUpdateBatch = true
    await this.getProductsBatch(row.id).then(res => {
      this.showUpdateBatch = false
    }).catch(err => {
      this.showUpdateBatch = false
    })
    this.showBatch = true
  }
  public loading: Boolean = false;
  private async getProductsBatch(id) {
    this.loading = true;
    const res: any = await getProductsBatch(id);
    this.batchList = res;
    this.batchList.map((item) => {
      item.batchListChai = item.batchList.toString("/");
    });
    this.loading = false;
  }

  private checkSelectedRows() {
    if (!this.allSelectedRows || this.allSelectedRows.length < 1) {
      Message.error("请选择装箱单");
      return true;
    }
    return false;
  }

  private handleBatchDelete() {
    if (this.checkSelectedRows()) return;
    const ids = this.allSelectedRows.map((value): string => value.id);
    this.$confirm("此次操作将会永久删除选择的装箱单, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.doBatchDelete(ids);
    });
  }

  private async doBatchDelete(ids: string[]) {
    await batchDeleteHqPackingList({ ids });
    await this.getList();
  }

  private selectAll() {
    (this.$refs.hqPackingListTable as any).toggleAllSelection();
  }

  private getRowKeys(row: IHqPackingListModel) {
    return row.id;
  }

  private onSelectionChange(allSelectedRows: IHqPackingListModel[]) {
    this.allSelectedRows = allSelectedRows;
  }

  private addFile(file: any) {
    if (file.size / 1024 / 1024 >= 100) {
      Message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
        duration: 2 * 1000,
      });
    }
    this.files.push(file);
  }

  private async handleUpload() {
    this.buttonLoading = true;
    let formData = new window.FormData();
    this.files.forEach((file) => formData.append("files", file.raw));
    formData.append("code", this.hqPackingListParentInfo.code);
    if (this.type === "delivery-note") {
      formData.append("type", HqPackingListType.DELIVERY_NOTE.toUpperCase());
    } else {
      formData.append(
        "type",
        HqPackingListType.FACTORY_LOADING_PLAN.toUpperCase()
      );
    }
    await uploadPackingList(formData)
      .then(() => {
        this.buttonLoading = false;
      })
      .catch(() => {
        this.buttonLoading = false;
      });
    this.clearFiles();
    await this.getList();
  }

  private handleReUpload(row: any) {
    if (this.files.length == 0) {
      return;
    }
    this.doReUpload(row);
  }

  private async updateFile(row: any) {
    let formData = new window.FormData();
    formData.append("file", row.file);
    await updatePackingListFile(row.data.id, formData);

    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private async doReUpload(row: any) {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    await reUploadPackingList(row.data.id, formData);
    await this.getList();
  }

  private handleDownload() {
    if (this.checkSelectedRows()) return;
    const hqPackingListIds = this.allSelectedRows.map(
      (value): string => value.id
    );
    this.doDownload(hqPackingListIds);
  }

  private handleCreateDeliveryTime() {
    if (this.checkSelectedRows()) return;
    this.timeHqPackingListIds = [];
    this.timeHqPackingListIds = this.allSelectedRows
      .filter((value) => value.canCreateDeliveryTime)
      .map((value): string => value.id);
    this.dialogStatus = "createDeliveryTime";
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private purchaseReceipt(id: string) {
    this.$confirm('正在进行采购入库操作，请确认是否入库', '提示', {
      confirmButtonText: '',
      cancelButtonText: '',
      type: 'warning',
    }).then(() => {
      this.confirmWarehousingForced(id);
    }).catch(() => {
      this.$message({
        type: "info",
        message: '取消入库',
      });
    });
  }

  private async leaveToPurchasing(id: string) {
    await leaveToPurchasing(id);
    await this.getList();
  }

  private async markDisposed(row) {
    await markErrorStatus(row.id)
      .then((res) => {
        this.$notify({
          title: "提示",
          message: "标记入库待处置成功",
          type: "success",
          duration: 2000,
        });
      })
      .catch((err) => {
        console.log(err);
      });
    this.getList();
  }

  private async closeDisposed(row) {
    await markErrorStatus(row.id)
      .then((res) => {
        this.$notify({
          title: "提示",
          message: "取消待处置成功",
          type: "success",
          duration: 2000,
        });
      })
      .catch((err) => {
        console.log(err);
      });
    this.getList();
  }

  private async doDownload(hqPackingListIds: any) {
    const response: any = await downloadHqPackingList({
      hqPackingListIds: hqPackingListIds,
    });
    const resultUrl: string[] = response;
    if (resultUrl.length > 0) {
      downloadFiles(resultUrl);
    }
  }

  private confirmScanning(row: IHqPackingListModel) {
    this.$router.push({
      name: "CustomsPackingConfirmScanning",
      params: {
        deliveryNoteId: this.hqPackingListParentInfo.id,
        hqPackingListId: row.id,
      },
    });
  }

  private inventoryListVisible = false;
  private inventoryListLoading = false;
  private inventoryList: InventoryList[] = [];

  private showInventoryList(row: IHqPackingListModel) {
    this.getInventoryList(row.code);
    this.inventoryListVisible = true;
  }

  private async getInventoryList(code: string) {
    this.inventoryListLoading = true;
    const data: any = await getInventoryList(code);
    this.inventoryList = data;
    this.inventoryListLoading = false;
  }

  private updateInventoryListVisible = false;
  private currentRowData = new InventoryList();

  private showUpdateInventoryList(row: InventoryList) {
    this.updateInventoryListVisible = true;
    this.currentRowData = deepClone(row);
  }

  private inventoryListRequest = new WriteInventoryListRequest();

  private async updateInventoryList() {
    this.inventoryListRequest.hqPackingListCode =
      this.currentRowData.hqPackingListCode;
    this.inventoryListRequest.sideMarkProductModel =
      this.currentRowData.sideMarkProductModel;
    this.inventoryListRequest.sideMarkProductQuantity =
      this.currentRowData.sideMarkProductQuantity;
    this.inventoryListRequest.sideMarkProductTotalQuantity =
      this.currentRowData.sideMarkProductTotalQuantity;
    await updateInventoryList(
      this.currentRowData.id,
      this.inventoryListRequest
    );
    await this.getInventoryList(this.currentRowData.hqPackingListCode);
    this.updateInventoryListVisible = false;
  }

  private async inputChangeBatch({ val, row, column }) {
    if (column.key === "batch") {
      let params = {
        batch: val,
        purchaseOrder: row.row.purchaseOrder,
      };
      await putProductsBatch(this.batch_fa_id, params);
      this.$notify({
        title: "成功",
        message: "修改批次成功",
        type: "success",
        duration: 2000,
      });
      this.getProductsBatch(this.batch_fa_id);
    }
  }

  private async deleteInventoryList(row: InventoryList) {
    await deleteInventoryList(row.id, {
      hqPackingListCode: row.hqPackingListCode,
    });
    await this.getInventoryList(row.hqPackingListCode);
  }

  private async doMatch(row: IHqPackingListModel) {
    await doMatch({ hqPackingListCode: row.code }).then((value: any) => {
      if (value === true) {
        this.$msgbox({
          title: "消息",
          message: "匹配成功，是否确认入库",
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              await confirmWarehousing({ids: [row.id], confirmType: 2}).then(async ress => {
                done();
                await this.getList();
              }).catch(err => {
                done();
                console.log(err)
              });
            } else {
              done();
            }
          },
        });
      } else {
        this.$message({
          showClose: true,
          message: "匹配失败",
          type: "error",
        });
      }
    });
    await this.getList();
  }

  private async downloadInventoryList(code: string) {
    await downloadInventoryListExcel(code);
  }

  private async downloadMatchResult(code: string) {
    await downloadMatchResult(code);
  }

  private async confirmWarehousingForced(id: string) {
    await confirmWarehousing({ ids: [id], confirmType: 1 });
    await this.getList();
  }

  private async handleCreateInvoice(row: IHqPackingListModel) {
    if (!row.factoryDeliveryNoteId) {
      Message.error({
        message: "请先生成子进仓单",
        duration: 2000,
      });
      return;
    }
    if (this.problemTypes.length < 1) {
      const problemTypes: any = await getAllCustomsPackingProblemTypes();
      this.problemTypes = problemTypes;
    }
    await this.initJobPositionUsers();
    const data: any = await getWarehouseReceiptOriginalInfo({
      hqPackingListId: row.id,
    });
    this.warehouseReceipt = data;
    this.invoiceDialogStatus = "create";
    this.createWarehouseReceiptRequest = new CreateWarehouseReceiptRequest();
    this.problemsWithInvoice = this.problemTypes.map(
      (value) => new Problem(value, false, null)
    );
    this.createWarehouseReceiptRequest.hqPackingListId = row.id;
    this.createWarehouseReceiptRequest.packagesQuantityReceived =
      this.warehouseReceipt.packagesQuantityReceived;
    this.createWarehouseReceiptRequest.warehouseInVolume =
      this.warehouseReceipt.warehouseInVolume;
    this.createWarehouseReceiptRequest.deliveryLicensePlateNumber =
      this.warehouseReceipt.deliveryLicensePlateNumber;
    this.createWarehouseReceiptRequest.deliveryDriverTel =
      this.warehouseReceipt.deliveryDriverTel;
    this.createWarehouseReceiptRequest.pltWarehouseInVolume =
      this.warehouseReceipt.pltWarehouseInVolume;
    this.createWarehouseReceiptRequest.ctnWarehouseInVolume =
      this.warehouseReceipt.ctnWarehouseInVolume;
    this.createWarehouseReceiptRequest.code = this.warehouseReceipt.code;
    this.invoiceDialogVisible = true;
    this.createInvoiceLoading = false;
  }

  private getWarehouseInCharge() {
    //入库体积
    let pltWarehouseInVolume = Math.ceil(
      Number(this.createWarehouseReceiptRequest.pltWarehouseInVolume)
    );
    let ctnWarehouseInVolume = Math.ceil(
      Number(this.createWarehouseReceiptRequest.ctnWarehouseInVolume)
    );
    //装卸费
    let handleCharge = 0;
    if (this.createWarehouseReceiptRequest.carriageVehicleType) {
      if (
        this.createWarehouseReceiptRequest.carriageVehicleType.name ===
        "FLATBED"
      ) {
        handleCharge =
          pltWarehouseInVolume *
            this.warehouseReceipt.flatbedPalletHandlingUnitPrice +
          ctnWarehouseInVolume *
            this.warehouseReceipt.flatbedCartonHandlingUnitPrice;
      }
      if (
        this.createWarehouseReceiptRequest.carriageVehicleType.name === "VAN"
      ) {
        handleCharge =
          pltWarehouseInVolume *
            this.warehouseReceipt.vanPalletHandlingUnitPrice +
          ctnWarehouseInVolume *
            this.warehouseReceipt.vanCartonHandlingUnitPrice;
      }
      if (
        this.createWarehouseReceiptRequest.carriageVehicleType.name ===
        "HIGH_BAR_TRUCK"
      ) {
        handleCharge =
          pltWarehouseInVolume *
            this.warehouseReceipt.highBarTruckPalletHandlingUnitPrice +
          ctnWarehouseInVolume *
            this.warehouseReceipt.highBarTruckCartonHandlingUnitPrice;
      }
      if (
        this.createWarehouseReceiptRequest.carriageVehicleType.name ===
        "EXPRESS_UNIT_PRICE"
      ) {
        const volume =
          Number(this.createWarehouseReceiptRequest.pltWarehouseInVolume) +
          Number(this.createWarehouseReceiptRequest.ctnWarehouseInVolume);
        if (volume <= this.warehouseReceipt.freeVolume) {
          handleCharge = 0;
        } else {
          handleCharge = Math.ceil(volume) * this.warehouseReceipt.expressFee;
        }
      }
    }
    handleCharge = Math.ceil(handleCharge / 5) * 5;
    let warehouseInCharge = handleCharge;
    this.createWarehouseReceiptRequest.warehouseInCharge = warehouseInCharge;
    return warehouseInCharge;
  }

  private getTotalFee() {
    let totalFee =
      this.getWarehouseInCharge() +
      Number(this.warehouseReceipt.printingFee) +
      Number(this.createWarehouseReceiptRequest.overtimeFee) +
      Number(this.warehouseReceipt.waybillRemovingUnitPrice) *
        Number(this.createWarehouseReceiptRequest.waybillRemovingQuantity) +
      Number(this.createWarehouseReceiptRequest.sortingFee) +
      Number(this.createWarehouseReceiptRequest.otherFee);
    this.warehouseReceipt.totalFee = totalFee.toString();
    this.convertFeeToChinese();
    return totalFee;
  }

  private convertFeeToChinese() {
    const CN_NUMBERS: string[] = ['零', '壹', "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
    const CN_MONETETARY_UNIT: string[] = ["元", "拾", "佰", "仟", "万","拾万"];
    let chineseFee = "";
    let fee:any = Number(this.warehouseReceipt.totalFee);
    if (fee > 99999 || !Number.isInteger(fee)) {
      Message.error({
        message:"金额超过十万/存在小数位，请调整数据，如无问题，请联系开发人员",
        duration: 2000
      })
    }
    let i = 0;
    while (true) {
      let temp = Math.trunc(fee) % 10;
      let unit = "";
      unit = unit + CN_NUMBERS[temp];
      if (temp !== 0 || i === 0){ // 非零展示对应单位，末尾0始终展示中文 元
        unit = unit + CN_MONETETARY_UNIT[i];
      }
      if (!chineseFee.startsWith("零") || unit !== '零') {
        chineseFee = unit + chineseFee
      }
      fee = fee / 10;
      if (fee < 1)
        break;
      i++;
    }
    chineseFee = chineseFee + "整";
    chineseFee = chineseFee.replace("零元整","元整")
    this.warehouseReceipt.totalFeeInChinese = chineseFee;
  }

  private async getWarehouseReceipts(row) {
    await getWarehouseReceipts({ hqPackingListId: row.id }).then((res: any) => {
      this.warehouseReceipts = res;
    });
  }

  private async handleCheckInvoice(row: WarehouseReceiptModel) {
    await this.initJobPositionUsers();
    const data: any = await getWarehouseReceipt(row.id);
    this.warehouseReceipt = data;
    if (!this.warehouseReceipt.confirmed) {
      this.invoiceDialogStatus = "update";
      this.createWarehouseReceiptRequest = data;
      const problemTypes: any = await getAllCustomsPackingProblemTypes();
      this.problemTypes = problemTypes;
      this.problemsWithInvoice = this.problemTypes.map((value) => {
        let problems = this.warehouseReceipt.problems.filter((problem) =>
          problem.includes(value.desc)
        );
        if (problems.length === 0) {
          return new Problem(value, false, null);
        } else {
          let problem = problems[0];
          let matches: any = problem.match(/\d+/);
          return new Problem(value, true, matches[0]);
        }
      });
    } else {
      this.invoiceDialogStatus = "check";
    }
    this.invoiceDialogVisible = true;
    this.createInvoiceLoading = false;
  }

  private async onInvoiceDialogConfirmed(confirmed: boolean,closeDialog: boolean) {
    this.createInvoiceLoading = true;
    if (
      this.invoiceDialogStatus === "create" ||
      this.invoiceDialogStatus === "update"
    ) {
     await this.doCreateInvoice(confirmed,closeDialog);
    }
  }

  private onFactoryDeliveryNoteDialogConfirmed(row: IHqPackingListModel) {
    if (this.factoryDeliveryNoteDialogStatus === "create") {
      this.doCreateFactoryDeliveryNote(row.id);
    } else if (this.factoryDeliveryNoteDialogStatus === "check") {
    }
  }

  private async downloadFactoryDeliveryNote(hqPackingListId: string) {
    await downFactoryDeliveryNote(hqPackingListId).catch(() => {
      return Message.error({ message: "下载出错，请重新尝试" });
    });
  }

  private async doCreateFactoryDeliveryNote(hqPackingListId: string) {
    const timeRange: Date[] =
      this.createFactoryDeliveryNoteRequest.warehouseInTimeRange;
    this.createFactoryDeliveryNoteRequest.warehouseInStartTime = timeRange[0];
    this.createFactoryDeliveryNoteRequest.warehouseInEndTime = timeRange[1];
    await createFactoryDeliveryNote(hqPackingListId);
    this.factoryDeliveryNoteDialogVisible = false;
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private async doCreateInvoice(confirmed: boolean, closeDialog: boolean) {
    this.createWarehouseReceiptRequest.problems =
      this.problemsWithInvoice.filter((value) => value.checked);
    if (confirmed === null) {
      await createWarehouseReceipt(this.createWarehouseReceiptRequest).finally(
        () => {
          this.createInvoiceLoading = false;
        }
      );
    } else {
      this.createWarehouseReceiptRequest.confirmed = confirmed;
      await updateWarehouseReceipt(
        this.warehouseReceipt.id,
        this.createWarehouseReceiptRequest
      ).finally(() => {
        this.createInvoiceLoading = false;
      });
    }
    if (closeDialog) {
      this.invoiceDialogVisible = false;
      await this.getList();
    }
  }

  private async initJobPositionUsers() {
    if (Object.keys(this.jobPositionAndUsersMap).length < 1) {
      const data: any = await getUsersByJobPositions({
        jobPositionTypes: this.JOB_POSITION_NAMES.join(","),
      });
      this.jobPositionAndUsersMap = data;
    }
  }

  private handleProblemDialogVisible = false;
  private problemHqPackingList: HqPackingListDetail = new HqPackingListDetail();
  private selectedProblemCustomsPackingIds: string[] = [];
  private removeProblemCustomsPackingLoading = false;

  private handleProblem(row: IHqPackingListModel) {
    this.currentRow = row;
    this.handleProblemDialogVisible = true;
    this.problemHqPackingList = new HqPackingListDetail();
    this.getProblemHqPackingListPackingInfo(row.id);
  }

  private showHistory = false;

  private handleHistory(row: IHqPackingListModel) {
    this.currentRow = row;
    this.showHistory = true;
  }

  private canReUpload(row: IHqPackingListModel) {
    return (
      row.state.name === "UPLOADED" ||
      row.state.name === "NOT_IN_STORAGE" ||
      row.state.name === "INBOUND_PENDING" ||
      (row.state.name === "NO_DATA" && this.type !== "factory-loading-plan")
    );
  }

  getProblemHqPackingListPackingInfo(hqPackingListId: string) {
    getProblemPackingInfo(hqPackingListId).then((res: any) => {
      this.problemHqPackingList = new HqPackingListDetail();
      this.problemHqPackingList.customsPackingSet = res;
    });
  }

  private handleProblemCustomsPackingSelectionChanged(rows: TableRowData[]) {
    this.selectedProblemCustomsPackingIds = rows.map((value) => value.id);
  }

  private async doHandleProblemCustomsPacking() {
    await updateProblemCustomsPackingState({
      hqPackingListId: this.currentRow.id,
      ids: this.selectedProblemCustomsPackingIds,
    });
    this.getProblemHqPackingListPackingInfo(this.currentRow.id);
  }

  private async doRemoveProblemCustomsPacking() {
    this.$confirm("确定移除主包装的异常记录吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
      confirmButtonClass: "el-button--danger",
    })
      .then(async () => {
        this.removeProblemCustomsPackingLoading = true;
        try {
          await deleteProblemCustomsPacking({
            ids: this.selectedProblemCustomsPackingIds,
          });
          this.$notify({
            title: "提示",
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          this.getProblemHqPackingListPackingInfo(this.currentRow.id);
        } catch (err) {
          console.error(err);
        }
        finally {
          this.removeProblemCustomsPackingLoading = false;
        }
      })

  }

  private checkProblemCustomsPackingImage(customsPackingId: string) {
    this.$router.push({
      name: "ImageManagement",
      params: {
        bizType: "customs-packing",
        objectId: customsPackingId,
      },
    });
  }

  private reUploadPrompts(row: IHqPackingListModel) {
    this.$confirm(
      "重新上传,此操作将删除已经配置的柜型信息，是否继续？",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    ).then(() => {
      this.currentRow = row;
      let ref = this.$refs["reUpload"] as any;
      ref.$refs["upload-inner"].handleClick();
    });
  }

  private clearFiles() {
    this.files = [];
    this.batchUploadDialogVisible = false;
  }

  private handleRemove(
    file: ElUploadInternalFileDetail,
    fileList: ElUploadInternalFileDetail[]
  ) {
    this.files = fileList.filter((value) => value.name !== file.name);
  }

  private downloadList() {
    const data = this.hqPackingLists.map((value) => {
      return {
        code: value.code,
        uploadDate: value.createdAt,
        factoryName: value.factoryName,
        state: value.state.desc,
        purchaserName: value.purchaserName,
        warehouseInTime: value.actualWarehouseInTime,
        whoConfirm: value.whoConfirm,
        confirmType:
          value.confirmType === null
            ? null
            : value.confirmType === 1
            ? "手动入库"
            : "扫码入库",
        remark: value.remark,
      };
    });
    const headers = [
      "装箱单号",
      "上传日期",
      "工厂",
      "状态",
      "负责采购员",
      "进仓/入库时间",
      "入库者",
      "入库方式",
      "备注",
    ];
    const fieldNames = [
      "code",
      "uploadDate",
      "factoryName",
      "state",
      "purchaserName",
      "warehouseInTime",
      "whoConfirm",
      "confirmType",
      "remark",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `装箱单-${new Date()}`
    );
  }

  private async showCombiningCustomsPackingDialog(id: string,source: boolean) {
    let params = {
      source: source
    }
    const data: any =
      await getCustomsPackingInfoWithCombiningDifferentPackingList(id,params);
    this.originalInfos = data;
    this.originalInfos.map((item,index) => {
      item.sn = index + 1;
    })
    if(source) {
      this.combiningCustomsPackingInfoVisibleGO = false;
      this.combiningCustomsPackingInfoVisible = true;
    } else {
      this.combiningCustomsPackingInfoVisible = false;
      this.combiningCustomsPackingInfoVisibleGO = true;
    }
  }

  /**
   * 打印单据的第一个预览页面。
   * @private
   */
  private  openDialog() {
      this.printInvoiceVisible = true;
  }
  private async handleEditAccountPeriodDate(
    startTime: Date,
    packingListId: string
  ) {
    await updateAccountPeriodStartTime(packingListId, startTime).then(res => {
      startTime = null;
      this.getList();
    }).catch(err => {
      console.log(err);
    });
  }

  updateFee(newVal:number) {
    if (newVal < 0){
      Message.error({
        message:"面单处理费不能小于0",
        duration: 2000
      })
    }
    let newFee:any = Number(this.warehouseReceipt.waybillRemovingUnitPrice) * newVal;
    this.warehouseReceipt.waybillRemovingFee = newFee
  }
}

class WriteHqPackingListInput {
  id: string;
  remark: string;
  deliveryStartTime: Date;
  deliveryEndTime: Date;
  carriageVehicleType?: string;
  contacts?: string;
  shippingMark?: string;
  selfCode?: string;
  palletNumber?: number;
  cartonNumber?: number;
  totalProductQuantity?: number;
  grossWeight?: number;
  hqPackingListCode?: string;
  hqPackingListId?: string;
  deliveryDriverTel?: string;
  deliveryLicensePlateNumber?: string;
  customsProductName?: string;
  deliveryFactoryName?: string;
  deliveryNoteCode?: string;
  hsCode?: string;
  mapImage?: string;
  remarks?: string;
  reservedStorageLayerName?: string;
  specificAddress?: string;
  volume?: number;
  warehouseAddress?: string;
  warehouseInInstructions?: string;
  warehouseInStartTime?: string;
  warehouseInEndTime?: string;
  warehouseName?: string;
  warehouseInTime?: any[];
  estimatedSailingSchedule?: string;
  factoryCode?: string;
  factoryName?: string;
  purchaser?: string;
  estimatedVolume?: number;
}

class WriteInventoryListRequest {
  hqPackingListCode: string;
  sideMarkProductModel: string;
  sideMarkProductQuantity: string;
  sideMarkProductTotalQuantity: number;
}

/*子进仓单模型*/
class FactoryDeliveryNoteModel {
  factoryDeliveryNote: FactoryDeliveryNote = new FactoryDeliveryNote();
  currentDate: string;
}

class FactoryDeliveryNote {
  hqPackingListId: string;
  factoryName: string;
  deliveryNoteCode: string;
  deliveryStartTime: string;
  deliveryEndTime: string;
  hqPackingListCode: string;
  storageLayerName: string;
  purchaseOrderNumbers: string;
  descriptions: string;
  shippingMark: string;
  productQuantity: number;
  selfCode: string;
  palletQuantity: number;
  cartonQuantity: number;
  customsPackingQuantity: number;
  volume: string;
  grossWeight: string;
  remark: string;
  purchaserName: string;
}

class CreateFactoryDeliveryNoteRequest {
  hqPackingListId: string;
  carriageVehicleType: string;
  warehouseInStartTime: Date;
  warehouseInEndTime: Date;
  deliveryLicensePlateNumber: string;
  deliveryDriverTel: string;
  warehouseInTimeRange: Date[];
}

//* 入库凭证 */
class WarehouseReceiptModel {
  id: string;
  code: string;
  hqPackingListId: string;
  factoryName: string;
  deliveryNoteCode: string;
  customsProductNames: string;
  warehouseInTime: string;
  totalProductQuantity: number;
  packagesQuantityReceived: number;
  warehouseInVolume: string;
  cargoPackaging: string;
  storageLayers: string;
  problems: string[];
  warehouseInCharge: string;
  printingFee: string;
  overtimeFee: string;
  waybillRemovingFee: string;
  waybillRemovingQuantity: number;
  waybillRemovingUnitPrice: string;
  otherFee: string;
  sortingFee: string;
  totalFee: string;
  expressFee: number;
  freeVolume: number;
  remark: string;
  deliveryLicensePlateNumber: string;
  deliveryDriverTel: string;
  tallyManId: string;
  forkliftOperatorId: string;
  documentsManagerId: string;
  warehouseAddress: string;
  warehouseTel: string;
  contracts: string;
  ctnWarehouseInVolume: string;
  pltWarehouseInVolume: string;
  carriageVehicleType: carriageVehicleType;
  flatbedCartonHandlingUnitPrice: number;
  vanCartonHandlingUnitPrice: number;
  highBarTruckCartonHandlingUnitPrice: number;
  flatbedPalletHandlingUnitPrice: number;
  vanPalletHandlingUnitPrice: number;
  highBarTruckPalletHandlingUnitPrice: number;
  hqPackingListCode: string;
  shippingMark: string;
  consignee: string;
  tollCollector: string;
  auditor: string;
  printer: string;
  cartonQuantity: number;
  palletQuantity: number;
  totalFeeInChinese: string;
  problemQuantity: number;
  problemDesc: string;
  storageLayerForPrint: string;
  printerProductName: string;
  confirmed: boolean;
}

class CreateWarehouseReceiptRequest {
  hqPackingListId: string;
  packagesQuantityReceived: number = null;
  warehouseInVolume: string = null;
  tallyManId: string;
  forkliftOperatorId: string;
  documentManagerId: string;
  waybillRemovingQuantity: string = null;
  sortingFee: string = null;
  remark: string = null;
  otherFee: string = null;
  deliveryLicensePlateNumber: string = null;
  problems: Problem[] = [];
  displayProblems: Problem[] = [];
  deliveryDriverTel: string = null;
  overtimeFee: string = null;
  ctnWarehouseInVolume: string = null;
  pltWarehouseInVolume: string = null;
  warehouseInCharge: number;
  carriageVehicleType: carriageVehicleType;
  consignee: string;
  tollCollector: string;
  auditor: string;
  printer: string;
  code: string;
  confirmed: boolean;
}

class carriageVehicleType {
  name: string;
  desc: string;
}

class Problem {
  checked: boolean;
  type: string;
  desc: string;
  quantity: number;

  constructor(problemType: ProblemType, checked: boolean, quantity: number) {
    this.type = problemType.name;
    this.desc = problemType.desc;
    this.checked = checked;
    this.quantity = quantity;
  }
}

class ProblemType {
  name: string;
  desc: string;
}

class OriginalPackingInfo {
  newCustomsPackingCode: string;
  oldCustomsPackingCode: string;
  productNames: string;
  hqPackingListCode: string;
  deliveryNoteCode: string;
  sn: any;
}

class OssFile {
  id: string;
  url: string;
  createdAt: Date;

  constructor(id: string, url: string, createdAt: Date) {
    this.id = id;
    this.url = url;
    this.createdAt = createdAt;
  }

  static fromAPIData(apiData: any): OssFile {
    return new OssFile(apiData.id, apiData.ossUrl, new Date(apiData.createdAt));
  }
}
